import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnInit, Renderer2, SimpleChanges } from '@angular/core';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { BadgeOptions } from '../badge/badge.interface';
import { ZuperDrawerService } from '@zuper/components/zuper-drawer';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { ProductService } from 'app/core/services/products/products.service';

@Component({
  selector: 'app-bundle-details',
  templateUrl: './bundle-details.component.html',
  styleUrls: ['./bundle-details.component.scss'],
  changeDetection: ChangeDetectionStrategy?.OnPush
})
export class BundleDetailsComponent implements OnInit, OnChanges {
  @Input() productDetails: any = {};
  @Input() drawerName: string = 'viewBundleDetailDrawer';
  isDetailsExpanded: boolean = true;
  selectedBundleItems: any = [];
  showSellingPrice: boolean = false;
  companyConfig: any;
  userRole: string = '';
  bundleLevelPricing: any = {
    'BUNDLE': 'text.bundle_pricing_bundle',
    'ROLLUP': 'text.bundle_pricing_rollup'
  };
  selectedBundleItemsDisplayedColumns: Array<string> = ['index','product', 'category', 'line_item_type', 'price', 'quantity'];

  constructor(public utilityService: UtilityService,
              public localStorageService: LocalStorageService,
              private drawerService: ZuperDrawerService,
              private changeDetectorRef: ChangeDetectorRef,
              private renderer: Renderer2,
              private eleRef: ElementRef,
              private dataCollectorService: DataCollectorService,
              private productService: ProductService
  ) { }

  ngOnInit(): void {
    this.showSellingPrice = this.utilityService.hasPermission('product.show_selling_price');
    this.companyConfig = this.localStorageService.getLocalStorage('company_configuration_data');
    this.userRole = this.localStorageService.getLocalStorage('user')?.role.role_key || '';
    this.changeDetectorRef.markForCheck();
  }

  setLineItems(): void{
    this.selectedBundleItems = this.productDetails?.associated_products ?? [];
    this.changeDetectorRef.markForCheck();
  }

  setLineClamp(flag, index): void {
    const element = this.eleRef.nativeElement.querySelector('.description-' + index);

    if (element) {
      if (flag) {
        this.renderer.addClass(this.eleRef.nativeElement.querySelector('.description-' + index), 'line-clamp clamped-text');
      }
      else {
        this.renderer.removeClass(this.eleRef.nativeElement.querySelector('.description-' + index), 'line-clamp clamped-text');
      }
    }

  }

  getActiveStatusOptions(status): BadgeOptions{
    const badgeOption: BadgeOptions = {
      type: this.getActiveStatusBadgeOption('type',status),
      displayKey: this.getActiveStatusBadgeOption('displayKey',status),
      displayName: this.getActiveStatusBadgeOption('displayName',status),
      backgroundColor: status ? '#dcfce7' : '#fee2e2',
      color: status ? '#166534' : '#991b1b',
      extraClass: 'capitalize'
    };
    return badgeOption;
  }

  getActiveStatusBadgeOption(key,value): string{
    switch(key){
      case 'type':
        return value ? 'AVAILABLE' : 'UNAVAILABLE';
      case 'displayKey':
        return value ? 'product.available.sufix.message' : 'text.unavailable';
      case 'displayName':
        return value ? 'Available' : 'Unavailable';
    }
  }

  getProductType(type: string): string{
    switch(type){
      case 'PARTS':
        return this.utilityService.getLocaleValue('text.part', 'Part');
      case 'PRODUCT':
        return this.utilityService.getLocaleValue('product.text', 'Product');
      case 'SERVICE':
        return this.utilityService.getLocaleValue('text.service', 'Service');
      case 'BUNDLE':
        return this.utilityService.getLocaleValue('text.bundle', 'Bundle');
    }
  }

  toggleDrawer(drawerName: any): void{
    const drawer = this.drawerService.getComponent(drawerName);
    drawer.close();
  }


  ngOnChanges(changes: SimpleChanges): void {
    if('productDetails' in changes){
      this.productDetails = changes?.productDetails?.currentValue;
      this.setLineItems();
      this.changeDetectorRef.markForCheck();
    }
    if('drawerName' in changes){
      this.drawerName = changes?.drawerName?.currentValue;
      this.setLineItems();
      this.changeDetectorRef.markForCheck();
    }
  }

}
